<template>

 <div class="wrapper">
    <CRow class="mt-3">
      
      <CCol sm="4">
        <CCard>
          <CCardHeader><b> Event Form </b> </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                
                <!-- <label> <b> Category Event  </b></label> -->
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      v-model="form.category"
                      :aria-describedby="ariaDescribedby"
                      hidden
                    >
                      <b-form-radio :aria-describedby="ariaDescribedby" name="category" value="conggregation">Conggregation</b-form-radio>
                      <b-form-radio :aria-describedby="ariaDescribedby" name="category" value="global">Global</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>       
              </CCol>
            </CRow>
           
            <CRow>
              <CCol sm="12">
                <label> <b> Event Name </b> </label>
                <b-input v-model="form.name" :state="validationName" id="feedback-user" class="mb-1"> </b-input>
                <b-form-invalid-feedback :state="validationName">
                Your event name must be filled
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validationName">
                Looks Good.
                </b-form-valid-feedback>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol sm="12">
              <label><b> Description Event </b> </label>
              <c-textarea v-model="form.description" rows="8" class="mb-3" />
              </CCol>
            </CRow>    
             <CRow>
              <CCol sm="12">
              <!-- <label><b> Available Event </b> </label> -->
              <b-form-select hidden v-model="form.available" :options="options_available"></b-form-select>
              </CCol>
            </CRow>        
            <CRow>
              <CCol sm="8">        
                <label> <b>Date Event</b></label>
                <datetime class="animated-placeholder" format="YYYY-MM-DD H:i:s" width="100%" readonly v-model="form.datetime_event" :disabled="form.status == 'publish'"></datetime>
              </CCol>
            </CRow>  
            <CRow>
              <CCol sm="8">
                <label> <b> Date Publish </b></label>
                <datetime class="animated-placeholder" format="YYYY-MM-DD H:i:s" width="100%" readonly v-model="form.datetime_publish" :disabled="form.status == 'publish'"></datetime>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="8">
                <label> <b> Date Close Registration </b></label>
                <datetime class="animated-placeholder" format="YYYY-MM-DD H:i:s" width="100%" readonly v-model="form.datetime_close" :disabled="form.status == 'publish'"></datetime>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol sm="12">
                <b-form-checkbox 
                
                id="checkbox-1"
                v-model="form.force_date"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                :disabled="form.status == 'publish'"
                >
                
                <b>FORCE DATE</b> this event.
                </b-form-checkbox>
                 
              </CCol>
            </CRow> 
           <CRow class="mt-3">
              <CCol sm="12">
              <label> <b> Location </b> </label>
              <b-input v-model="form.location"> </b-input> 
              </CCol>
            </CRow> 

            <CRow class="mt-3">
              <CCol sm="12">
              <label> Link (jika ada)</label>
              <b-input v-model="form.link"> </b-input> 
              </CCol>
            </CRow>


            <hr>
            <CRow class="mt-3">
              <CCol sm="12">
              <label> <b> Additional Link </b> </label>
              </CCol>
            </CRow>
           <CRow class="mt-3" v-for="index in num_add_link" :key="index">
              <CCol sm="6">
                <label> Text {{ index }}</label>
                <b-input v-model="add_text[index-1]" @change="add_link_array()"> </b-input> 
              </CCol>
              <CCol sm="6">
                <label> Link {{ index }}</label>
                <b-input v-model="add_link[index-1]" @change="add_link_array()"> </b-input> 
              </CCol>
            </CRow> 
            <hr>


            <CRow class="mt-3">
              <CCol sm="12">
              <label> Background Image</label>
              <p v-if="btn_create" style="color:blue;">Resolusi gambar sebaiknya 2:1 | contoh 600x300 / 1568x784</p>
              <b-form-file v-if="btn_create" size="sm" v-model="form.file" class="mt-3" plain></b-form-file>
              </CCol>
              <CCol sm="12">
              <img v-bind:src="getImage(bgimage)" style="width:200px"/>
              <CButton class="ml-3" v-if="btn_update" type="button" @click="openModalPhotoBGImage(form.id)"  variant="outline" color="info">Update BG Image</CButton>
              </CCol>
              
            </CRow>
            <CRow class="mt-3">
              <CCol sm="12">
              <label> Banner Image</label>
              <p v-if="btn_create" style="color:blue;">Resolusi gambar sebaiknya 720 x 120</p>
              <b-form-file v-if="btn_create" size="sm" v-model="form.file_banner" class="mt-3" plain></b-form-file>
              </CCol>
              <CCol sm="12">
              <img v-bind:src="getImage(bannerimage)" style="width:200px"/>
              <CButton class="ml-3" v-if="btn_update" type="button" @click="openModalPhotoBannerImage(form.id)"  variant="outline" color="info">Update Banner Image</CButton>

              </CCol>
            </CRow>
          </CCardBody>  
        </CCard>
      </CCol>

      <CCol sm="8">
        <CCard>
          <CCardHeader><b> Transaction Form </b> </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <label><b> Admission Fee </b> </label>
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="form.admission_fee"
                    :aria-describedby="ariaDescribedby"
                    :disabled="form.status == 'publish'"
                  >
                  <b-form-radio  :aria-describedby="ariaDescribedby" name="fee" value="free">Free</b-form-radio>
                  <b-form-radio  :aria-describedby="ariaDescribedby" name="fee" value="paid">Paid</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>     
              </CCol>
            </CRow>
            <hr>
            <CRow v-if="form.admission_fee == 'paid'">
              
              <CCol sm="12">
                <b>Payment Method </b>
                <b-form-checkbox-group
                class="mt-2"
                id="checkbox-group-1"
                
                v-model="option_payment_selected"
                :options="options_payment"
                :aria-describedby="ariaDescribedby"
                name="flavour-1"
                ></b-form-checkbox-group>
              </CCol>
            </CRow>
          </CCardBody>  
        </CCard>   
        <CCard>
          <CCardHeader>
           <b> Custom Field </b>
            <CBadge class="float-right"><CButton class="float-right" color="info" size="sm" block variant="outline" @click="addRowField(temp_index_field)">Add</CButton></CBadge>
          </CCardHeader>
          <CCardBody>
            <CRow>
            </CRow>
            <CRow>
              <CCol lg="12">
                <div class="panel-body" id="app">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Field Label</th>
                        <th>Type</th>
                        <th>Detail</th>
                        <th>Is Required?</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-sortable.tr="rows">
                      <tr v-for="(arr, index) in form.form_field" :key="index">
                        <td>
                          <c-textarea rows="5" cols="150" v-model="arr.label"/>
                        </td>
                        <td>
                          <b-form-select v-model="arr.type" style="width: 110%" :options="options_type_field"></b-form-select>
                        </td>
                        <td>
                          <c-textarea 
                          placeholder=
                            "pilihan diisi per baris 
                            contoh:
                            yes
                            no" 
                          v-if="arr.type != 'Text'" v-model="arr.temp" rows="5" @input="array_of_lines(index)"/>                       
                        </td>
                        <td>
                          <b-form-checkbox 
                          
                          :id="'checkbox2' + index"
                          v-model="arr.required"
                          :name="'checkbox2' + index"
                          value="1"
                          unchecked-value="0"
                          >
                          </b-form-checkbox>
                        </td>  
                        <td >
                          <CButton class="mt-1" color="danger" block size="sm" variant="outline" @click="removeRowField(index)">Remove</CButton>
                        </td>
                  
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CCol>
            </CRow>
          </CCardBody>  
        </CCard>   
        <CCard>
          <CCardHeader> <b>
            Ticket Type </b>
            <CBadge class="float-right"><CButton class="float-right" color="info" size="sm" block variant="outline" @click="addRowTicket(temp_index_ticket)" :disabled="form.status == 'publish'">Add</CButton></CBadge>
          </CCardHeader>
          <CCardBody>
            <CRow>
            </CRow>
            <CRow>
              <CCol lg="12">
                <div class="panel-body" id="app">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Price</th>
                        <th>Max Ticket per Transaction</th>
                        <th>Quota</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-sortable.tr="rows">
                      <tr v-for="(arr, index) in form.custom_tickets" :key="index">
                        <td>
                          <input class="form-control" v-model="arr.name" :disabled="form.status == 'publish'"/>
                        </td>
                        <td>
                          <input class="form-control" v-model="arr.description" :disabled="form.status == 'publish'"/>
                        </td>
                        <td>
                          <input class="form-control" v-model="arr.price" number :disabled="form.admission_fee == 'free'"/>
                        </td>
                        <td>
                          <input class="form-control" v-model="arr.max"  number :disabled="form.status == 'publish'"/>
                        </td>
                        <td>
                          <input class="form-control" v-model="arr.quota"  number/>
                        </td>
                        <td>
                          <CButton class="mt-1" color="danger" block size="sm" variant="outline" @click="removeRowTicket(index)" :disabled="form.status == 'publish'">Remove</CButton>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CCol>
            </CRow>
          </CCardBody>  
        </CCard> 
        
        <CButton v-if="btn_create" block type="submit" v-on:click.prevent="create()"   color="info"><b>Create </b></CButton>
        <CButton v-if="btn_update" block type="submit" v-on:click.prevent="update(form.id)"   color="info">Update</CButton>
       
      </CCol>
      
    </CRow>



      
    <alertmodal></alertmodal>
    <modalphotobg></modalphotobg>
    <modalphotobanner></modalphotobanner>
    
  </div>
</template>

<script>
import datetime from 'vuejs-datetimepicker';
import event from '@/services/event';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

import setting from '@/services/setting';

import modalphotobg from './event_modal_photo_bgimage.vue';
import modalphotobanner from './event_modal_photo_bannerimage.vue';

export default {
  name: 'Dashboard',
  components: {
    alertmodal,datetime,modalphotobg,modalphotobanner
  },
  data () {
    return {
      btn_create: 0,
      btn_update: 0,
     form:{
        id: '',
        category:'global',
        name:'',
        description:'',
        available:'g',
        datetime_event:'',
        datetime_publish:'',
        datetime_close:'',
        location:'',
        link:'',
        file:'',
        file_banner:'',
        admission_fee:'free',
        force_date:'',
        form_field: [
            {label: ""},
        ],
        custom_tickets: [
            {name: "", description: "", price: "",max: "",quota: ""},
        ],
        payment_information: "",
        status:'',
        additional_link:''
    },
    bgimage:'',
    bannerimage:'',
    temp_data: '',

    temp_index_ticket: 0,
    temp_index_field: 0,

      option_payment_selected:[],
      options_payment_temp:[],
      options_payment:[],


          options_available:[
            { text: 'Private ', value: 'a' },
            { text: 'iCare Coach', value: 'b' },
            { text: 'ICL and Core Team ', value: 'c' },
            { text: 'Head of Department', value: 'd' },
            { text: 'All Volunteers and Covenants ', value: 'e' },
            { text: 'Youth', value: 'f' },
            { text: 'Everyone ', value: 'g' },
          ],
      options_type_field:[
            { text: 'Text', value: 'Text' },
            { text: 'Checkbox', value: 'Checkbox' },
            { text: 'Radio', value: 'Radio' },
      ],
      num_add_link: 2, // increase if needed
      add_text:[],
      add_link:[],
      add_temp_array:[]
    }
  
  },

  mounted(){
    this.loadData()
          EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
  },

  created () {
    
  },

   beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('TABLE_UPDATE')
  },

  methods: {
    array_of_lines: function (index) {
      var str = this.form.form_field[index].temp;
      var arrayOfLines = str.split("\n");
      this.form.form_field[index].detail = arrayOfLines;
      //this.form.form_field[index].value_checkbox = [];
      this.form.form_field[index].value = [];
    },

    loadData(){
        this.temp_index_field = this.temp_index_field - 1;
        this.form.form_field.splice(0, 1);
        this.temp_index_ticket = this.temp_index_ticket - 1;
        this.form.custom_tickets.splice(0, 1);


      if(this.$route.query.id){
        this.btn_update = 1;
        // this.temp_index_field = this.temp_index_field - 1;
        // this.form.form_field.splice(0, 1);
        // this.temp_index_ticket = this.temp_index_ticket - 1;
        // this.form.custom_tickets.splice(0, 1);

        event.getEventbyID(this.$route.query.id)
        .then(res => {
          this.form.id = res.data.id;
          this.form.name = res.data.name;
          this.form.description = res.data.description;
          this.form.datetime_event = res.data.datetime_event;
          this.form.datetime_publish = res.data.datetime_publish;
          this.form.datetime_close = res.data.datetime_close;
          this.form.force_date = res.data.force_date;
          this.form.location = res.data.location;
          this.form.link = res.data.link;
          this.bgimage = res.data.bgimage;
          this.bannerimage = res.data.bannerimage;

          this.form.status = res.data.status;

          this.form.category = res.data.category;
          this.form.available = res.data.available;
          //this.form.form_field = res.data.form_field;

          // this.temp_data = JSON.parse(res.data.form_field);
          // for (let i=0; i <= this.temp_data.length-1; i++){
          //   //alert
          //   this.form.form_field.push({label: this.temp_data[i].label})
          //   console.log('test');
          // }

          this.form.form_field = JSON.parse(res.data.form_field);

          this.form.admission_fee = res.data.admission_fee;
          
          this.temp_data = JSON.parse(res.data.payment_information);
          for (let i=0; i <= this.temp_data.length-1; i++){
            //alert
            this.option_payment_selected.push({
              bank: this.temp_data[i].bank,
              account: this.temp_data[i].account,
              description: this.temp_data[i].description,
            })
            console.log('test');
          }

          for (let i=0; i <= res.data.event_tickets.length-1; i++){
            //alert
            this.form.custom_tickets.push({
              id: res.data.event_tickets[i].id,
              name: res.data.event_tickets[i].name,
              description: res.data.event_tickets[i].description,
              price: res.data.event_tickets[i].price,
              max: res.data.event_tickets[i].max,
              quota: res.data.event_tickets[i].quota,
            })
            console.log('test');
          }

          // additional link using format {text1}---{link1}~~~{text2}---{link2}
          this.form.additional_link = res.data.additional_link;
          this.add_temp_array = this.form.additional_link.split("~~~")
          for (let i=0; i <= this.num_add_link-1; i++){
            var temp_arr = []
            temp_arr = this.add_temp_array[i].split("---")
            this.add_text[i] = temp_arr[0]
            this.add_link[i] = temp_arr[1]
          }

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        this.btn_create = 1;
      }

      setting.getSetting("paymentmethod")
      .then(res => {
        this.options_payment_temp = JSON.parse(res.data.value);
        for (let i=0; i <= this.options_payment_temp.length-1; i++){
          this.options_payment.push({text: this.options_payment_temp[i].bank + " " + this.options_payment_temp[i].account, value: this.options_payment_temp[i]})
        }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })  
    }, 
    addRowTicket: function (index) {
        try {
            this.temp_index_ticket = this.temp_index_ticket + 1;
            this.form.custom_tickets.splice(index + 1, 0, {});
        } catch(e)
        {
            console.log(e);
        }
    },
    removeRowTicket: function (index) {
        this.temp_index_ticket = this.temp_index_ticket - 1;
        this.form.custom_tickets.splice(index, 1);
    },

    addRowField: function (index) {
        try {
          this.temp_index_field = this.temp_index_field + 1;
          this.form.form_field.splice(index + 1, 0, {type: "Text"});
        } catch(e)
        {
            console.log(e);
        }
    },
    removeRowField: function (index) {
      this.temp_index_field = this.temp_index_field - 1;
      this.form.form_field.splice(index, 1);
    },

    create(){
        this.form.payment_information = this.option_payment_selected

        let formData = new FormData();
        formData.append('category', this.form.category);
        formData.append('name', this.form.name);
        formData.append('description', this.form.description);
        formData.append('available', this.form.available);
        formData.append('datetime_event', this.form.datetime_event);
        formData.append('datetime_publish', this.form.datetime_publish);
        formData.append('datetime_close', this.form.datetime_close);
        formData.append('location', this.form.location);
        formData.append('link', this.form.link);
        formData.append('file', this.form.file);
        formData.append('file_banner', this.form.file_banner);
        formData.append('admission_fee', this.form.admission_fee);
        formData.append('force_date', this.form.force_date);
        formData.append('form_field', JSON.stringify(this.form.form_field));
        formData.append('custom_tickets', JSON.stringify(this.form.custom_tickets));
        formData.append('payment_information', JSON.stringify(this.form.payment_information));
        formData.append('additional_link', this.form.additional_link);

        event.createEvent(formData)
        .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            setTimeout(() => {  this.$router.push({name:'Event Page' }) }, 1500);
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },

    timeout(ms) { //pass a time in milliseconds to this function
    return new Promise(resolve => setTimeout(resolve, ms));
  },

    update(id){
        this.form.payment_information = this.option_payment_selected
        event.updateEvent(id,this.form)
        .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
    getImage(url){
        if (url){
          return url;
        }else{
          return '';
        }
    },
    openModalPhotoBGImage(id){
        var params = {title: 'Update BG Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BGIMAGE', params)
        console.log('load modal photo')      
    },
    openModalPhotoBannerImage(id){
        var params = {title: 'Update Banner Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BANNERIMAGE', params)
        console.log('load modal photo')      
    },

    add_link_array() {
      // additional link using format {text1}---{link1}~~~{text2}---{link2}
      console.log('add link combine')
        this.form.additional_link = ''
        for (let i=0; i <= this.num_add_link-1; i++){
          var text = ''
          var link = ''
          if (this.add_text[i] != null) text = this.add_text[i]
          if (this.add_link[i] != null) link = this.add_link[i]
          var temp = text + '---' + link + '~~~'
          //var temp = this.add_text[i] + '---' + this.add_link[i]
          this.form.additional_link += temp
        }
    }

  }
}
</script>
